import utils from '../styles/utils';

export const getExtensionFromName = (name: string) => {
    const tryExt = String(name).split('.').pop();

    if (tryExt == undefined) {
        return 'default';
    }
    if (allowedFileExtensions.find((ext) => ext === tryExt.toLocaleLowerCase())) {
        return tryExt;
    }
    return 'default';
};
const allowedFileExtensions = [
    'docx',
    'xlsx',
    'csv',
    'pptx',
    'pdf',
    'jpeg',
    'png',
    'zip',
    'mp3',
    'mp4',
    'jpg',
    'txt',
    'odt',
    'svg',
    'psd',
    'ttf',
    'otf',
    'ai',
];

function getIcon(name: string, color: string, basePath: string) {
    return {
        path: basePath + name,
        colors: {
            primary: color,
            light: utils.getLightShade(color, 0.6),
            dark: utils.getDarkShade(color, 0.3),
        },
    };
}
export function getIconExtensionFile(fileName: string, basePath: string) {
    const extension = getExtensionFromName(fileName);
    switch (String(extension).toLocaleLowerCase()) {
        case 'docx':
        case 'odt':
            return getIcon('docx.png', '#0263D1', basePath);
        case 'xlsx':
        case 'csv':
            return getIcon('xlsx.png', '#00733B', basePath);
        case 'pptx':
            return getIcon('pptx.png', '#E03303', basePath);
        case 'pdf':
            return getIcon('pdf.png', '#CC2353', basePath);
        case 'zip':
            return getIcon('zip.png', '#566DC6', basePath);
        case 'mp3':
            return getIcon('mp3.png', '#8762D7', basePath);
        case 'mp4':
            return getIcon('mp4.png', '#218273', basePath);
        case 'svg':
            return getIcon('svg.png', '#EA80CA', basePath);
        case 'psd':
            return getIcon('psd.png', '#4DA7E6', basePath);
        case 'otf':
        case 'ttf':
            return getIcon('ttf.png', '#131E4B', basePath);
        case 'ai':
            return getIcon('ai.png', '#ED8200', basePath);
        default:
            return getIcon('default.png', '#7EDDCF', basePath);
    }
}
